// extracted by mini-css-extract-plugin
export var productImage = "_qa-1";
export var viewLink = "_qa-2";
export var wishlistItem = "_qa-0";